import { ClientService } from "../client-service/client-service";
import { ComponentDependencyTree } from "../component-dependency-tree/component-dependency-tree";
import { BLOG_DOCUMENTS } from "./blog-paths"

document.addEventListener('DOMContentLoaded', () => {
    const latestBlog = BLOG_DOCUMENTS[0];
    const clientService = ComponentDependencyTree.clientService;

    const template = `
<style>
    .blog-info-container {
        border: 1px solid var(--body-color);
        border-radius: 10px;
        padding: 1em;
        cursor: pointer;
        margin-bottom: 1em;
    }

    .blog-info-container:hover {
        background-color: var(--input-border-color);
    }

    .blog-info {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 1em;
        padding-bottom: 1em;
    }

    .blog-img {
        align-self: center;
        --width: auto;
        --max-width: 100%;
        --max-height: 15em;
    }

    .blog-title {
        text-align: center;
        font-size: 1.3em;
    }
</style>
<div class="blog-info">
    ${latestBlog.metadata.meta_img ? `<img-smart class="blog-img" src="${latestBlog.metadata.meta_img}"></img-smart>` : ``}
    <h3 class="blog-title">${latestBlog.metadata.meta_title}</h3>
    <div>
        <p><b>Date: </b>${latestBlog.metadata.date_created}</p>
        <p><b>Description: </b>${latestBlog.metadata.meta_description}</p>
    </div>
</div>
    `;

    document.getElementById('blog-info-container')!.innerHTML = template;
    document.getElementById('blog-info-container')!.addEventListener('click', () => {
        console.log("[MoreLatestBlog] path opening", latestBlog.path);
        const updatedUrl = clientService.createLocalLink(
            "blog/" + latestBlog.path,
            {},
            true
        );
        console.log("[MoreLatestBlog] navigating", updatedUrl)
        window.location.href = updatedUrl;
    })
});